module.exports = __webpack_public_path__ + "static/media/TZ.70dd4d9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/TZ.svg
// module id = 2282
// module chunks = 7